function Select({ placeholder, title, options,value,changeValueHandler }) {
    return <div className="w-[90%] md:w-[30%] mb-7 relative mx-auto h-10 border-2 p-2 border-solid rounded-[2px] border-[#14223D]">
        <select value={value} onChange={(e)=>changeValueHandler(e.target.value)} className="w-full">
            <option>{placeholder}</option>
            {options.map((option, index) => {
                return <option key={index} value={option.value}>{option.label}</option>
            })}
        </select>
        <span className="absolute top-[-35%]  right-[10%] px-3 text-orange bg-white z-2">{title}</span>
    </div>
}

export default Select